// extracted by mini-css-extract-plugin
module.exports = {"statistics":"WelcomeAppraiser_statistics__36SWl","registration":"WelcomeAppraiser_registration__3J4eS","member-login":"WelcomeAppraiser_member-login__339H4"};